import React from "react";

import { Status } from "./partials/film-table.jsx";
import connectToStores from "alt-utils/lib/connectToStores";
import FilmActions from "../actions/FilmActions";
import FilmStore from "../stores/FilmStore";
import VirtualContentActions from "../actions/VirtualContentActions";
import UserStore from "../stores/UserStore";
import EventBucketStore from "../stores/EventBucketStore";
import VirtualContentStore from "../stores/VirtualContentStore";
import VirtualContentUtil from "../utils/VirtualContentUtil";
import juration from "juration";

import InlineNoticeLabel from "./partials/inline-notice-label.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";
import moment from "moment";
import {
  Dialog,
  FlatButton,
  RaisedButton,
  Checkbox,
  RadioButtonGroup,
  RadioButton,
  Paper
} from "material-ui";
import ChatWidget from "./partials/chat-widget.jsx";
import Label from "./partials/label.jsx";
import LiveEventDiagnostics from "./partials/live-event-diagnostics.jsx";
import ChatReviewQueue from "./partials/chat-review-queue.jsx";

const THREESIXTY_VR_ENABLED = true;

class Film extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditing: false,
      isExporting: false,
      pinging: false,
      checkCountdown: null
    };
  }

  static getStores() {
    return [UserStore, EventBucketStore, FilmStore, VirtualContentStore];
  }

  static getPropsFromStores() {
    return {
      ...FilmStore.getState(),
      getEventBucketById: EventBucketStore.getEventBucketById,
      isEditing: VirtualContentStore.getState().isEditing
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {
      flexContainer: {
        display: "flex",
        gap: "20px" // Adds spacing between columns
      },
      leftPane: {
        maxWidth: 700,
        flex: 1
      },
      rightPane: {
        maxWidth: 700,
        flex: 1
      }
    };
  }

  pingUntilStatuses(statuses) {
    const ping = () => {
      const film = FilmStore.getFilmById(this.props.params.filmId);
      if (
        film &&
        film.virtual_content &&
        statuses.indexOf(film.virtual_content.status) > -1
      ) {
        // Done
        this.setState({ pinging: false, isEditing: false });
      } else {
        FilmActions.fetchOne(this.props.params.filmId);
        this.pingTimeout = setTimeout(() => ping(), 4000);
      }
    };
    this.pingTimeout = setTimeout(() => ping(), 4000);
  }

  componentWillUnmount() {
    if (this.pingTimeout) {
      clearTimeout(this.pingTimeout);
    }
  }

  componentDidUpdate() {
    const film = FilmStore.getFilmById(this.props.params.filmId);
    if (!this.state.pinging && film && film.virtual_content) {
      if (
        film.virtual_content.status === "livestream_creating" ||
        film.virtual_content.status === "livestream_previewing_creating"
      ) {
        this.setState({ pinging: true }, () => {
          this.pingUntilStatuses([
            "livestream_create_failure",
            "livestream_created"
          ]);
        });
      } else if (
        film.virtual_content.status === "livestream_creating_preview"
      ) {
        this.setState({ pinging: true }, () => {
          this.pingUntilStatuses([
            "livestream_create_failure",
            "livestream_previewing"
          ]);
        });
      } else if (
        film &&
        film.virtual_content &&
        film.virtual_content.status === "livestream_stopping"
      ) {
        this.setState({ pinging: true }, () => {
          this.pingUntilStatuses([
            "livestream_stop_failure",
            "livestream_publish_failure",
            "livestream_stopped"
          ]);
        });
      }
    }
  }

  startStreaming(id, toPreview) {
    this.setState({ pinging: true, isEditing: true }, () => {
      VirtualContentActions.startStreaming(id);
      this.pingUntilStatuses(
        ["livestream_create_failure", "livestream_created"].concat(
          toPreview ? ["livestream_previewing"] : []
        )
      );
    });
  }

  stopStreaming(id) {
    this.setState({ pinging: true, isEditing: true }, () => {
      VirtualContentActions.stopStreaming(id);
      this.pingUntilStatuses([
        "livestream_stop_failure",
        "livestream_publish_failure",
        "livestream_stopped"
      ]);
    });
  }

  export(id) {
    this.setState({ isExporting: true });
    VirtualContentUtil.export(UserStore.getState().apiKey, id)
      .then(res => {
        this.setState({ isExporting: false });
        if (res.export_url) {
          this.setState({ showExportUrlModal: res.export_url });
        } else if (res.export_status === "export_in_progress") {
          this.checkInProgressExport(id);
        }
        FilmActions.fetchOne(this.props.params.filmId);
      })
      .catch(e => {
        this.setState({ isExporting: false });
        window.alert(`Failed to export: ${e.message}`);
      });
  }

  checkInProgressExport(id, continuing) {
    let { checkCountdown } = this.state;
    if (continuing && checkCountdown === 1) {
      this.export(id);
    } else {
      this.setState({ checkCountdown: continuing ? checkCountdown - 1 : 10 });
      setTimeout(() => this.checkInProgressExport(id, true), 1000);
    }
  }

  componentDidMount() {
    FilmActions.fetchOne(this.props.params.filmId);
  }

  componentWillReceiveProps(props) {
    if (!props.isEditing && this.props.isEditing) {
      FilmActions.fetchOne(this.props.params.filmId);
    }
    const film = FilmStore.getFilmById(this.props.params.filmId);
    if (
      film &&
      film.virtual_content &&
      film.virtual_content.export_status === "export_in_progress" &&
      this.state.checkCountdown === null
    ) {
      this.checkInProgressExport(film.virtual_content.id);
    }
  }

  render() {
    let styles = this.getStyles();
    const film = FilmStore.getFilmById(this.props.params.filmId);
    const eventBucket = this.props.getEventBucketById(
      this.props.params.eventBucketId
    );

    if (!film || !eventBucket) {
      return <WorkingIndicator fullPage={true} />;
    }

    const intro = (
      <div>
        <h1>Livestreaming for {film.name}</h1>
        <p style={{ fontSize: "11pt" }}>
          Scheduled start: {moment(film.start_time).format("LLL")}
          <br />
          Scheduled end: {moment(film.end_time).format("LLL")}
          {UserStore.isGod() ? (
            <span>
              <br />
              Virtual content ID: {film.virtual_content.id}{" "}
              {film.virtual_content.ev_next_encoding_id && (
                <span>
                  <a
                    href={`https://dashboard.bitmovin.com/live/encodings/${film.virtual_content.ev_next_encoding_id}`}
                    target="_blank"
                  >
                    View in Bitmovin
                  </a>{" "}
                </span>
              )}
              <InlineNoticeLabel
                label="God"
                style={{
                  verticalAlign: 3,
                  marginLeft: 4,
                  fontWeight: "bold"
                }}
              />
            </span>
          ) : null}
        </p>
      </div>
    );

    if (!film.virtual_content || film.livestream_mode !== "eventive") {
      const noticeStyle = {
        border: "2px dashed #ccc",
        borderRadius: 5,
        padding: "1em",
        fontSize: "13pt",
        display: "inline-block",
        maxWidth: 450
      };
      return (
        <div>
          {intro}
          {film.livestream_mode === "embedded" ? (
            <div style={noticeStyle}>
              This is an <i>embedded livestream</i>. This means that the content
              will automatically play from the embedded source, but no Eventive
              content protection or security will be applied. You can configure
              the source via the <strong>Virtual screening editor</strong>.
            </div>
          ) : film.livestream_mode === "external" ? (
            <div style={noticeStyle}>
              This is an <i>external instructions livestream</i>. This means
              that no player will be accessible directly on the Eventive site.
              You can configure the instructions that are displayed via the{" "}
              <strong>Virtual screening editor</strong>.
            </div>
          ) : (
            <div style={noticeStyle}>
              Livestreaming has not been enabled for this event.
            </div>
          )}
        </div>
      );
    }

    return (
      <div>
        {this.state.showExportUrlModal ? (
          <Dialog
            title="Your download is ready"
            actions={[
              <FlatButton
                label="Close"
                onTouchTap={() => this.setState({ showExportUrlModal: false })}
              />
            ]}
            modal={true}
            open={true}
            onRequestClose={() => this.setState({ showExportUrlModal: false })}
          >
            <div>
              Your media has been prepared. In order to ensure your browser
              downloads the file and doesn't attempt to play it,{" "}
              <strong>
                right-click the button below and select "Save link as...".
              </strong>
            </div>
            <RaisedButton
              style={{ marginTop: "1em" }}
              download={`eventive-livestream-export-${film.virtual_content.id}.mp4`}
              primary
              href={this.state.showExportUrlModal}
              target="_blank"
              label="Download media (right-click)"
              onClick={e => {
                e.preventDefault();
                window.alert(
                  'Please right-click the button and select "Save link as..." to ensure your browser does not attempt to play the media in a new tab.'
                );
              }}
            />
            <div style={{ marginTop: "1em" }}>
              Having issues with the export? Please get in touch using the chat
              widget in the lower righthand corner of your screen.
            </div>
          </Dialog>
        ) : null}
        {intro}
        <div>
          <Paper
            style={{
              // border: "2px dashed #ccc",
              borderRadius: 15,
              padding: "0 1em",
              fontSize: "13pt",
              display: "inline-block",
              minWidth: 400
            }}
          >
            {film.virtual_content.livestream_preview_egress_url &&
            ["livestream_previewing", "livestream_created"].includes(
              film.virtual_content.status
            ) ? (
              <div
                style={{
                  float: "right",
                  width: 500,
                  height: 280,
                  paddingTop: "1em",
                  paddingLeft: "2em",
                  paddingBottom: "1em"
                }}
              >
                <iframe
                  style={{
                    width: "100%",
                    height: "100%"
                  }}
                  frameBorder="0"
                  scrolling="no"
                  allow="autoplay; encrypted-media; fullscreen"
                  src={`${
                    process.env.WATCH_SITE_ROOT
                  }admin/livepreview?url=${encodeURIComponent(
                    film.virtual_content.livestream_preview_egress_url
                  )}`}
                />
              </div>
            ) : null}
            <p>
              <strong>Status:</strong>{" "}
              <Status virtual_content={film.virtual_content} />
            </p>
            {film.virtual_content.type === "broadcast" ? (
              <p>
                This is a VOD real-time broadcast. It will start and end
                automatically.
              </p>
            ) : (
              [
                "livestream_created",
                "livestream_previewing",
                "livestream_previewing_creating",
                "livestream_stopping",
                "livestream_stop_failure"
              ].indexOf(film.virtual_content.status) > -1 && (
                <p style={{ wordBreak: "break-word" }}>
                  <strong>RTMP url:</strong>{" "}
                  {film.virtual_content.livestream_ingest_urls &&
                  film.virtual_content.livestream_ingest_urls.length
                    ? film.virtual_content.livestream_ingest_urls
                        .slice(0, 1)
                        .map(e => <div>{e}</div>)
                    : "none"}
                  <br />
                  <strong>Stream key:</strong>{" "}
                  {film.virtual_content.livestream_stream_key || "default"}
                </p>
              )
            )}
            {film.virtual_content.status === "livestream_previewing" ? (
              <p>
                <strong>
                  You're live in the Preview Window and billing is active. When
                  you're ready to stream to your audience, click below to go
                  live!
                </strong>
                <div style={{ marginTop: "0.5em", fontSize: "0.75em" }}>
                  After clicking, it may take up to 30 seconds to go live.
                </div>
                <div style={{ marginTop: "1em" }}>
                  <RaisedButton
                    label="Go live to audience"
                    primary={true}
                    disabled={this.state.isEditing}
                    onTouchTap={() =>
                      this.startStreaming(film.virtual_content.id)
                    }
                  />
                  <RaisedButton
                    style={{ marginLeft: 7 }}
                    label="Abort stream permanently"
                    primary={false}
                    disabled={this.state.isEditing}
                    onTouchTap={() => {
                      if (
                        window.confirm(
                          `Are you sure? You can never start this livestream again.`
                        )
                      ) {
                        this.stopStreaming(film.virtual_content.id);
                      }
                    }}
                  />
                </div>
              </p>
            ) : film.virtual_content.status === "livestream_created" ? (
              <p>
                <strong>
                  You're live now and streaming to your audience! When your
                  event has concluded, click below to stop streaming.
                </strong>
              </p>
            ) : null}
            {film.virtual_content.type !== "broadcast" &&
              ["livestream_not_created", "livestream_create_failure"].indexOf(
                film.virtual_content.status
              ) > -1 && (
                <div>
                  <div
                    style={{
                      fontSize: "10pt",
                      margin: "-0.5em 0 1em 0",
                      maxWidth: 500
                    }}
                  >
                    <div>
                      <Label>Livestream mode</Label>
                      <RadioButtonGroup
                        name="drm"
                        valueSelected={
                          film.virtual_content.ams_drm_enabled ? "drm" : "none"
                        }
                        onChange={(e, v) =>
                          VirtualContentActions.edit(film.virtual_content.id, {
                            ams_drm_enabled: v === "drm",
                            livestream_premium_enabled: v === "drm",
                            asset_pathway: undefined
                          })
                        }
                      >
                        <RadioButton
                          value="none"
                          label={
                            <div>
                              <div>Basic</div>
                              <div
                                style={{ lineHeight: 1.2, fontSize: "0.9em" }}
                              >
                                Up to 720p resolution; basic security, single
                                bitrate, additional fee for organizer export, no
                                TV app playback (free)
                              </div>
                            </div>
                          }
                        />
                        <RadioButton
                          style={{ marginTop: 5 }}
                          value="drm"
                          label={
                            <div>
                              <div>
                                Premium{" "}
                                <InlineNoticeLabel
                                  label="Recommended"
                                  style={{
                                    verticalAlign: 1,
                                    marginLeft: 2,
                                    fontWeight: "bold"
                                  }}
                                />
                              </div>
                              <div
                                style={{ lineHeight: 1.2, fontSize: "0.9em" }}
                              >
                                Up to 1080p resolution;{" "}
                                {film.virtual_content.source_video_layout ===
                                "360_single"
                                  ? ""
                                  : "multi-platform MPAA-approved DRM security, "}
                                adaptive bitrate quality re-encoding, free
                                organizer HD export, TV app support, and free
                                automatic captions (US$10/hr + US$0.99/unlock)
                              </div>
                            </div>
                          }
                        />
                      </RadioButtonGroup>
                    </div>
                    {/* <div>
                    <Label>Livestream quality</Label>
                    <RadioButtonGroup
                      name="quality"
                      valueSelected={
                        film.virtual_content.livestream_premium_enabled
                          ? "premium"
                          : "basic"
                      }
                      onChange={(e, v) =>
                        VirtualContentActions.edit(film.virtual_content.id, {
                          livestream_premium_enabled: v === "premium"
                        })
                      }
                    >
                      <RadioButton
                        value="basic"
                        label="Basic single feed (free)"
                      />
                      <RadioButton
                        value="premium"
                        label="Premium adaptive bitrate (US$2.99/hour)"
                      />
                    </RadioButtonGroup>
                  </div> */}
                    <div>
                      <Label>Livestream accessibility</Label>
                      <Checkbox
                        // disabled={window.location.search.indexOf("beta=1") === -1}
                        label={
                          <div>
                            Real-time automatic captions (
                            {film.virtual_content.livestream_premium_enabled ? (
                              <span>
                                <span
                                  style={{ textDecoration: "line-through" }}
                                >
                                  US$0.03/min
                                </span>{" "}
                                <span style={{ fontWeight: "bold" }}>
                                  free with Premium
                                </span>
                              </span>
                            ) : (
                              "US$0.03/min"
                            )}
                            ){" "}
                          </div>
                        }
                        checked={
                          film.virtual_content.livestream_transcription_enabled
                        }
                        onCheck={(e, checked) => {
                          VirtualContentActions.edit(film.virtual_content.id, {
                            livestream_transcription_enabled: checked
                          });
                        }}
                      />
                    </div>

                    {THREESIXTY_VR_ENABLED ? (
                      <div>
                        <Label>Advanced options</Label>
                        <Checkbox
                          label={<div>360°/VR livestream playback mode</div>}
                          checked={
                            film.virtual_content.source_video_layout ===
                            "360_single"
                          }
                          onCheck={(e, checked) => {
                            VirtualContentActions.edit(
                              film.virtual_content.id,
                              {
                                source_video_layout: checked
                                  ? "360_single"
                                  : null
                              }
                            );
                          }}
                        />
                      </div>
                    ) : null}

                    <div style={{ marginBottom: 15 }}>
                      <Label>Livestream preview window</Label>
                      <RadioButtonGroup
                        name="preview"
                        valueSelected={
                          film.virtual_content.livestream_preview_first !==
                          false
                            ? "preview"
                            : "none"
                        }
                        onChange={(e, v) =>
                          VirtualContentActions.edit(film.virtual_content.id, {
                            livestream_preview_first: v === "preview"
                          })
                        }
                      >
                        <RadioButton
                          value="preview"
                          label={
                            <div>
                              Start with preview window for up to 1 hour before
                              going live
                              <div
                                style={{ lineHeight: 1.2, fontSize: "0.9em" }}
                              >
                                Connect your inputs, preview your stream, and
                                check video/audio levels. Then click to begin
                                streaming to your audience within the next 60
                                minutes.
                              </div>
                            </div>
                          }
                        />
                        <RadioButton
                          style={{ marginTop: 5 }}
                          value="none"
                          label="Immediately stream to audience once inputs are connected"
                        />
                      </RadioButtonGroup>
                    </div>
                  </div>

                  <RaisedButton
                    label={
                      film.virtual_content.livestream_preview_first !== false
                        ? "Start streaming to preview window"
                        : "Start streaming"
                    }
                    primary={true}
                    disabled={this.state.isEditing}
                    onTouchTap={() =>
                      this.startStreaming(
                        film.virtual_content.id,
                        film.virtual_content.livestream_preview_first
                      )
                    }
                  />
                  <div
                    style={{
                      marginTop: "1.25em",
                      fontSize: "11pt",
                      maxWidth: 500
                    }}
                  >
                    <strong>
                      Before you click "start streaming" above, remember...
                    </strong>
                    <ul style={{ marginTop: "0.5em", paddingLeft: "2em" }}>
                      <li style={{ marginBottom: "0.25em" }}>
                        <strong>
                          You can only start a livestream once, even when you're
                          using the preview window!
                        </strong>{" "}
                        If you're testing, do it in a test screening instead.
                        You can never restart a stream.
                      </li>
                      <li style={{ marginBottom: "0.25em" }}>
                        It may take up to 5 minutes for your dedicated
                        livestream to fully initialize after clicking the
                        button, so click a few minutes early!
                      </li>
                      <li>
                        Please stream responsibly.{" "}
                        <strong>
                          YOU are responsible for clicking “Stop streaming” when
                          your livestream is complete.
                        </strong>{" "}
                        Abuse of the livestreaming platform, including
                        long-running unattended or abandoned streams, will
                        result in loss of streaming privileges.
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            {["livestream_creating"].indexOf(film.virtual_content.status) >
              -1 && (
              <p>
                <RaisedButton
                  label="Starting..."
                  primary={true}
                  disabled={true}
                />
              </p>
            )}
            {["livestream_created", "livestream_stop_failure"].indexOf(
              film.virtual_content.status
            ) > -1 && (
              <p>
                <RaisedButton
                  label="Stop streaming"
                  primary={true}
                  disabled={this.state.isEditing}
                  onTouchTap={() => this.stopStreaming(film.virtual_content.id)}
                />
              </p>
            )}
            {["livestream_stopping"].indexOf(film.virtual_content.status) >
              -1 && (
              <p>
                <RaisedButton
                  label="Stopping..."
                  primary={true}
                  disabled={true}
                />
              </p>
            )}
            {["livestream_stopped"].indexOf(film.virtual_content.status) >
              -1 && (
              <div>
                <p>
                  Livestream mode:{" "}
                  {film.virtual_content.type === "broadcast"
                    ? "Premium Broadcast"
                    : film.virtual_content.livestream_premium_enabled
                    ? "Premium"
                    : "Basic"}
                  {film.virtual_content.livestream_transcription_enabled
                    ? " (w/ Live Transcription)"
                    : ""}
                  <br />
                  Actual start:{" "}
                  {film.virtual_content.livestream_started_at
                    ? moment(film.virtual_content.livestream_started_at).format(
                        "LLL"
                      )
                    : "Unknown"}
                  <br />
                  Actual end:{" "}
                  {film.virtual_content.livestream_stopped_at
                    ? moment(film.virtual_content.livestream_stopped_at).format(
                        "LLL"
                      )
                    : "Unknown"}
                  <br />
                  Actual duration:{" "}
                  {film.virtual_content.duration
                    ? juration.stringify(film.virtual_content.duration / 1000)
                    : "Unknown"}
                </p>
                {film.virtual_content.type === "broadcast" ? (
                  <div>
                    <p>The real-time broadcast has concluded successfully.</p>
                  </div>
                ) : (
                  <div>
                    {film.virtual_content.livestream_premium_enabled ? (
                      <p>
                        Your Premium Livestream includes a full HD downloadable
                        export if you wish to use this asset in a
                        non-Eventive-hosted setting.
                      </p>
                    ) : (
                      <p>
                        For Basic livestreams, an HD downloadable export can be
                        generated for US$20 (free with Premium).
                      </p>
                    )}
                    <p>
                      {film.virtual_content.export_status ===
                      "export_not_requested" ? (
                        <RaisedButton
                          label={
                            this.state.isExporting
                              ? "Requesting HD export..."
                              : `Request HD export${
                                  film.virtual_content
                                    .livestream_premium_enabled
                                    ? ""
                                    : " ($20)"
                                }`
                          }
                          primary={true}
                          disabled={this.state.isExporting}
                          onTouchTap={() =>
                            this.export(film.virtual_content.id)
                          }
                        />
                      ) : film.virtual_content.export_status ===
                        "export_in_progress" ? (
                        <i>
                          Your export is in progress now. Check back soon to
                          download.{" "}
                          {this.state.isExporting
                            ? "Checking now..."
                            : this.state.checkCountdown !== null
                            ? `Checking again in ${this.state.checkCountdown}...`
                            : ""}
                        </i>
                      ) : film.virtual_content.export_status ===
                        "export_ready" ? (
                        <RaisedButton
                          label={
                            this.state.isExporting
                              ? "Downloading completed HD export..."
                              : "Download completed HD export"
                          }
                          primary={true}
                          disabled={this.state.isExporting}
                          onTouchTap={() =>
                            this.export(film.virtual_content.id)
                          }
                        />
                      ) : film.virtual_content.export_status ===
                        "export_failure" ? (
                        "An error occurred while generating your export automatically. Please contact us using the support chat in the lower righthand corner so we can prepare your export manually."
                      ) : (
                        "Loading..."
                      )}
                    </p>
                    <p style={{ fontSize: "0.8em" }}>
                      Export may take up to an hour to render. Once generated
                      you can download your export an unlimited number of times
                      from this page at no additional charge.{" "}
                      {!film.virtual_content.livestream_premium_enabled &&
                        `A single fee of US$20 will
                  appear on your next monthly invoice.`}
                    </p>
                  </div>
                )}
              </div>
            )}
            {this.state.pinging && (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <WorkingIndicator
                  overlay={false}
                  style={{ marginBottom: "20px" }}
                />
              </div>
            )}
            {this.props.isEditing || this.props.isFetching ? (
              <WorkingIndicator overlay={true} />
            ) : null}
          </Paper>
        </div>
        <h2 style={{ marginTop: "2em" }}>Live chat management</h2>
        <div style={{ maxWidth: 400, fontSize: "11pt", margin: "1em 0" }}>
          <Checkbox
            label="Show live chat"
            checked={film.virtual_content.live_chat_visible}
            onCheck={(e, checked) => {
              VirtualContentActions.edit(film.virtual_content.id, {
                live_chat_visible: checked
              });
            }}
          />
          <Checkbox
            disabled={film.virtual_content.live_chat_visible === false}
            label="Show number of people currently viewing"
            checked={
              film.virtual_content.live_chat_visible &&
              film.virtual_content.live_chat_show_viewer_count
            }
            onCheck={(e, checked) => {
              VirtualContentActions.edit(film.virtual_content.id, {
                live_chat_show_viewer_count: checked
              });
            }}
          />
          <Checkbox
            disabled={film.virtual_content.live_chat_visible === false}
            label="Allow viewers to send messages"
            checked={
              film.virtual_content.live_chat_visible &&
              film.virtual_content.live_chat_participation_enabled
            }
            onCheck={(e, checked) => {
              VirtualContentActions.edit(film.virtual_content.id, {
                live_chat_participation_enabled: checked
              });
            }}
          />
        </div>
        <p style={{ fontSize: "11pt" }}>
          Your livestream includes a live chat. You can participate in the chat
          as {(UserStore.getUser() || {}).organization} below. You can delete
          messages, ban users, and more by hovering over a message and clicking
          on the three dots in the upper righthand corner of the message.
        </p>

        <div style={styles.flexContainer}>
          <div style={styles.leftPane}>
            <ChatWidget
              film={film}
              user={UserStore.getUser()}
              token={film.livechat_token}
            />
          </div>
          <div style={styles.rightPane}>
            <ChatReviewQueue film={film}></ChatReviewQueue>
          </div>
        </div>

        {UserStore.isGod() ? (
          <Paper
            style={{ marginTop: "2em", borderRadius: "15px", padding: "10px" }}
          >
            <h2 style={{ paddingTop: "10px" }}>
              Live stream diagnostics{" "}
              <InlineNoticeLabel
                label="God Beta"
                style={{
                  verticalAlign: 3,
                  marginLeft: 4,
                  fontWeight: "bold"
                }}
              />
            </h2>
            <p style={{ fontSize: "11pt" }}>
              Review live events as received from the media encoder. Newest
              events will appear at the top automatically&ndash;no need to
              refresh the page.
            </p>
            <LiveEventDiagnostics virtualContentId={film.virtual_content.id} />
          </Paper>
        ) : null}
      </div>
    );
  }
}

export default connectToStores(Film);



// WEBPACK FOOTER //
// ./src/app/components/virtual-festival-livestreaming-hub-film.jsx